import { useHistory } from 'react-router-dom';
import { useEffect, useState } from 'react';

const useTermsAndConditions = () => {
  const history = useHistory();
  const [isAccepted, setIsAccepted] = useState<boolean>(false);

  useEffect(() => {
    //get the termsAccepted from localStorage
    const termsAccepted = localStorage.getItem('termsAccepted');
    if (!termsAccepted || termsAccepted === 'false') {
      // If not authenticated or terms not accepted, redirect to login
      history.push('/onboarding/terms-and-conditions');
    } else {
      setIsAccepted(true);
    }
  }, [history]);

  return { isAccepted };
};

export default useTermsAndConditions;
